/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_LockedInputs */

const en_issue_locked = /** @type {(inputs: Issue_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`locked: ask Tomorrow to unlock it`)
};

/**
* | output |
* | --- |
* | "locked: ask Tomorrow to unlock it" |
*
* @param {Issue_LockedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_locked = /** @type {((inputs?: Issue_LockedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_LockedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_locked(inputs)
});